// extracted by mini-css-extract-plugin
export default {"adminPageWrapper":"AdminPage_adminPageWrapper__eJ9GA","inputs":"AdminPage_inputs__XDWcZ"};